import React from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";
import * as actions from "../redux/actions/adCommentActions";
import CommentPostCard from "./CommentPostCard";
import MiniLoader from "./MiniLoader";

class HeadComment extends React.Component {
  onClickReportComment = async () => {
    await this.props
      .ReportComment(this.props.token, {
        comment_id: this.props.comment.Id,
        id: this.props.user_id,
        lang: I18n.t("locale"),
      })
      .then(() => {
        if (!this.props.error) {
          alertify.success(I18n.t("success"));
        }
      });
  };

  onClickRemoveComment = async () => {
    await this.props.RemoveComment(this.props.token, {
      comment_id: this.props.comment.Id,
      id: this.props.user_id,
      lang: I18n.t("locale"),
    });
  };

  onClickUp = async () => {
    const { comment } = this.props;
    if (comment.Like === 1) {
      await this.props.RemoveLike(this.props.token, {
        comment_id: comment.Id,
        id: this.props.user_id,
        lang: I18n.t("locale"),
      });
    } else {
      await this.props.UpdateLike(this.props.token, {
        comment_id: comment.Id,
        status: "1",
        id: this.props.user_id,
        lang: I18n.t("locale"),
      });
    }
  };

  onClickDown = async () => {
    const { comment } = this.props;
    if (comment.Like === 0) {
      await this.props.RemoveLike(this.props.token, {
        comment_id: comment.Id,
        id: this.props.user_id,
        lang: I18n.t("locale"),
      });
    } else {
      await this.props.UpdateLike(this.props.token, {
        comment_id: comment.Id,
        status: "'0'",
        id: this.props.user_id,
      });
    }
  };

  render() {
    const { comment, commentId } = this.props;
    const isStale =
      commentId &&
      comment?.Id &&
      comment.Id.toString() !== commentId.toString();

    if (!comment?.Id || isStale) {
      return (
        <div className="comment-thread-parent-skeleton" aria-hidden="true">
          <div className="comment-thread-parent-skeleton-header">
            <span className="comment-thread-parent-skeleton-avatar" />
            <span className="comment-thread-parent-skeleton-lines">
              <span />
              <span />
            </span>
          </div>
          <span className="comment-thread-parent-skeleton-body" />
          <div className="wall-page-loading">
            <MiniLoader />
          </div>
        </div>
      );
    }

    return (
      <CommentPostCard
        comment={this.props.comment}
        user_id={this.props.user_id}
        featured
        onClickUp={this.onClickUp}
        onClickDown={this.onClickDown}
        onClickRemove={this.onClickRemoveComment}
        onClickReport={this.onClickReportComment}
      />
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    comment: reducer.adComment.item,
    error: reducer.adComment.error,
  };
}

const mapDispatchToProps = (dispatch) => ({
  ReportComment: (token, params) =>
    dispatch(actions.reportComment({ token, params })),
  RemoveComment: (token, params) =>
    dispatch(actions.removeComment({ token, params })),
  RemoveLike: (token, params) =>
    dispatch(actions.removeLike({ token, params })),
  UpdateLike: (token, params) =>
    dispatch(actions.updateLike({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeadComment);
